import { render, staticRenderFns } from "./CanadaPost.vue?vue&type=template&id=7832ddcd&scoped=true"
import script from "./CanadaPost.vue?vue&type=script&lang=js"
export * from "./CanadaPost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7832ddcd",
  null
  
)

export default component.exports